export function timer(now) {
    var st = now();
    return function stop() {
        return Math.round(now() - st);
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/timeTracker/timer.js
// module id = 1982
// module chunks = 25